<template>
  <q-card :data-test="CypressTarget('PromoterCard')">
    <q-card-title :data-test="CypressTarget('Title')">
      {{ $t('cards.promoter.title') }}
    </q-card-title>
    <q-card-main v-if="alias">
      <q-list no-border>
        <q-item>
          <q-item-side :data-test="CypressTarget('Name')">
            {{ $t('cards.promoter.name') }}:
          </q-item-side>
          <q-item-main>
            <q-item-tile
              :data-test="CypressTarget('Alias')"
              class="q-title"
              label
            >
              {{ alias }}
              <span
                v-if="city && state"
                class="q-caption"
              >
                {{ city }} - {{ state }}
              </span>
            </q-item-tile>
          </q-item-main>
        </q-item>
        <q-item v-if="description">
          <q-item-side :data-test="CypressTarget('DescriptionTitle')">
            {{ $t('cards.promoter.description') }}:
          </q-item-side>
          <q-item-main>
            <q-item-tile
              :data-test="CypressTarget('Description')"
              label
            >
              {{ description }}
            </q-item-tile>
          </q-item-main>
        </q-item>
      </q-list>
    </q-card-main>
    <q-card-separator />
    <q-card-actions>
      <q-field class="col-12">
        <q-btn
          :label="$t('cards.promoter.selectPromoter')"
          :data-test="CypressTarget('OpenDialog')"
          :color="SET_COLOR_BUTTON.primary"
          :text-color="SET_COLOR_BUTTON.text.primary"
          flat
          @click="$emit('selectPromoter', true)"
        />
        <slot />
      </q-field>
    </q-card-actions>
  </q-card>
</template>

<script>
  export default {
    name: 'CardCheckoutPromoter',
    props: {
      alias: {
        type: String,
        required: false,
        default: '',
      },
      city: {
        type: String,
        required: false,
        default: '',
      },
      state: {
        type: String,
        required: false,
        default: '',
      },
      description: {
        type: String,
        required: false,
        default: '',
      },
    },
  };
</script>
